import React from 'react';
import { Box, Icon, Link } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './PaymentFaqLink.styles';
import isSSR from '../../utils/isSSR';
const FaqLinkWrapper = themeStyles.apply(Box, 'PaymentFaqLinkWrapper');
const PaymentFaqLink = () => {
    const { t } = useTranslation();
    const paymentFaqLinkLabel = t('Pages.Bap.paymentOptionsFaqButton');
    let paymentFaqUrl = t('Pages.Bap.paymentOptionsFaqUrl');
    paymentFaqUrl = isSSR() ? paymentFaqUrl : `${window.location.origin}${paymentFaqUrl}`;
    return (React.createElement(FaqLinkWrapper, null,
        React.createElement(Link, { href: paymentFaqUrl, target: "_blank", rel: "noopener noreferrer", styling: "tertiary2" },
            paymentFaqLinkLabel,
            React.createElement(Icon, { ml: "12px", height: "12px", name: "arrowRight", iconColor: "blue" }))));
};
export default PaymentFaqLink;
